(function(){
  if(window.soleiaShippingProtectionInitialized)return;
  window.soleiaShippingProtectionInitialized=true;
  var protectionId=63081714090371;
  var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  function path(s){return root.replace(/\/$/,'/')+s;}
  var busy=false;
  function boxes(){return document.querySelectorAll('[data-soleia-protection]');}
  function loading(b){boxes().forEach(function(el){el.classList.toggle('is-loading',b);var input=el.querySelector('.soleia-sp-toggle');if(input)input.disabled=b;});}
  function error(message){boxes().forEach(function(el){var e=el.querySelector('.soleia-sp-error');if(e)e.textContent=message||'';});}
  function sync(cart){
    var selected=cart.items.some(function(i){return Number(i.variant_id)===protectionId;});
    boxes().forEach(function(el){var input=el.querySelector('.soleia-sp-toggle');if(input)input.checked=selected;});
  }
  async function json(url,settings){
    var response=await fetch(url,Object.assign({credentials:'same-origin'},settings||{}));
    var data=await response.json();
    if(!response.ok)throw new Error(data.description||data.message||'Could not update cart.');
    return data;
  }
  async function update(checked){
    if(busy)return;
    busy=true;loading(true);error('');
    try{
      var cart=await json(path('cart.js'));
      var line=cart.items.find(function(i){return Number(i.variant_id)===protectionId;});
      var other=cart.items.some(function(i){return Number(i.variant_id)!==protectionId;});
      if(checked&&!other)throw new Error('Please add a product before selecting shipping protection.');
      if((checked&&line)||(!checked&&!line)){sync(cart);return;}
      var body=checked?{id:protectionId,quantity:1}:{id:line.key,quantity:0};
      body.sections=['cart-drawer','cart-icon-bubble','main-cart-items','main-cart-footer'];
      body.sections_url=location.pathname;
      var result=await json(path(checked?'cart/add.js':'cart/change.js'),{
        method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)
      });
      if(/\/cart\/?$/.test(location.pathname)){location.reload();return;}
      var drawer=document.querySelector('cart-drawer');
      if(drawer&&typeof drawer.renderContents==='function'&&result.sections&&result.sections['cart-drawer']){
        drawer.renderContents(result);
      }else{location.reload();}
    }catch(e){
      error(e.message||'Unable to update cart.');
      try{sync(await json(path('cart.js')));}catch(_){}
    }finally{busy=false;loading(false);}
  }
  document.addEventListener('change',function(e){
    if(!e.target.matches('.soleia-sp-toggle'))return;
    update(e.target.checked);
  });
})();
